export const mixinQuiz = {
    data() {
      return {
        hostMap: {
          '.sitebuilder-publication.kub.app.builderall.io': {
            quiz: 'https://quiz.kub.app.builderall.io'
          },

          '.sitebuilder-publication.kub.app.builderall.info': {
            quiz: 'https://quiz.kub.app.builderall.info'     
          },
          
          'default': {
            quiz: 'https://quiz.builderall.com'            
          }
        }
      };
    },
    methods: {
      getQuizUrl(host = null) {        
        
        if (host !== null) {
          const foundKey   = Object.keys(this.hostMap).find(key => host.includes(key));
          const hostConfig = this.hostMap[foundKey] || this.hostMap['default'];
          
          return hostConfig.quiz;
        }

        return 'https://quiz.builderall.com';

      }
    }
  };
  